import Alert from 'antd/lib/alert';
import { useImportContext } from './ImportProvider';

export function ImportCompletedMessage() {
    const { importHasErrors } = useImportContext();

    if (importHasErrors) {
        return (
            <Alert
                showIcon
                type="warning"
                style={{ backgroundColor: 'white', border: 'none' }}
                message="Import Completed with Errors!"
                description="Please review errors above."
            />
        );
    }

    return (
        <Alert
            showIcon
            type="success"
            style={{ backgroundColor: 'white', border: 'none' }}
            message="Import Completed Successfully"
            description="Now you can close this dialog to see all imported records."
        />
    );
}
